<template>
  <div>Page Not Found</div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "PageNotFound",

  created: function () {
    if (process.env.NODE_ENV === "production") {
      window.location.href = "/404.html";
    }
  },
});
</script>

<style scoped />
